import { graphql } from "../../../models/autogenerated-deliveryService-gql";

export const CreateInboundDeliveryMutation = graphql(/* GraphQL */ `
  mutation createInboundDelivery(
    $createInboundDeliveryInput: CreateInboundDeliveryInput!
  ) {
    createInboundDelivery(input: $createInboundDeliveryInput) {
      inboundDeliveryDetail {
        id
      }
    }
  }
`);
